export default __webpack_public_path__ + "static/media/sort.db1c858c.svg";